import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import {
  FETCH_ESCALATION_POLICIES,
  FETCH_ESCALATION_POLICY,
  CREATE_ESCALATION_POLICY,
  UPDATE_ESCALATION_POLICY,
  DELETE_ESCALATION_POLICY,
  TOGGLE_ESCALATION_POLICY,
  FETCH_ESCALATION_EVENTS,
} from './actionTypes';
import {
  fetchEscalationPoliciesSuccess, fetchEscalationPoliciesFail,
  fetchEscalationPolicySuccess, fetchEscalationPolicyFail,
  createEscalationPolicySuccess, createEscalationPolicyFail,
  updateEscalationPolicySuccess, updateEscalationPolicyFail,
  deleteEscalationPolicySuccess, deleteEscalationPolicyFail,
  toggleEscalationPolicySuccess, toggleEscalationPolicyFail,
  fetchEscalationEventsSuccess, fetchEscalationEventsFail,
} from './actions';

function* fetchPoliciesSaga() {
  try {
    const { data } = yield call(api.get, 'escalation/list');
    yield put(fetchEscalationPoliciesSuccess(data.response));
  } catch (error) {
    yield put(fetchEscalationPoliciesFail(error.response?.data?.message || 'Failed to fetch policies'));
  }
}

function* fetchPolicySaga({ payload: id }) {
  try {
    const { data } = yield call(api.get, `escalation/get?id=${id}`);
    yield put(fetchEscalationPolicySuccess(data.response));
  } catch (error) {
    yield put(fetchEscalationPolicyFail(error.response?.data?.message || 'Failed to fetch policy'));
  }
}

function* createPolicySaga({ payload: { data: policyData, callback } }) {
  try {
    const { data } = yield call(api.post, 'escalation/create', policyData);
    yield put(createEscalationPolicySuccess(data.response));
    if (callback) callback();
  } catch (error) {
    yield put(createEscalationPolicyFail(error.response?.data?.message || 'Failed to create policy'));
  }
}

function* updatePolicySaga({ payload: { data: policyData, callback } }) {
  try {
    const { data } = yield call(api.put, 'escalation/update', policyData);
    yield put(updateEscalationPolicySuccess(data.response));
    if (callback) callback();
  } catch (error) {
    yield put(updateEscalationPolicyFail(error.response?.data?.message || 'Failed to update policy'));
  }
}

function* deletePolicySaga({ payload: { id, callback } }) {
  try {
    yield call(api.delete, `escalation/delete?id=${id}`);
    yield put(deleteEscalationPolicySuccess(id));
    if (callback) callback();
  } catch (error) {
    yield put(deleteEscalationPolicyFail(error.response?.data?.message || 'Failed to delete policy'));
  }
}

function* togglePolicySaga({ payload: { id, callback } }) {
  try {
    const { data } = yield call(api.put, `escalation/toggle?id=${id}`);
    yield put(toggleEscalationPolicySuccess(data.response));
    if (callback) callback();
  } catch (error) {
    yield put(toggleEscalationPolicyFail(error.response?.data?.message || 'Failed to toggle policy'));
  }
}

function* fetchEventsSaga({ payload: { page, size, policyId } }) {
  try {
    const params = new URLSearchParams();
    params.append('page', page || 0);
    params.append('size', size || 20);
    if (policyId) params.append('policyId', policyId);
    const { data } = yield call(api.get, `escalation/events?${params.toString()}`);
    yield put(fetchEscalationEventsSuccess(data.response));
  } catch (error) {
    yield put(fetchEscalationEventsFail(error.response?.data?.message || 'Failed to fetch events'));
  }
}

export default function* escalationSaga() {
  yield takeLatest(FETCH_ESCALATION_POLICIES, fetchPoliciesSaga);
  yield takeLatest(FETCH_ESCALATION_POLICY, fetchPolicySaga);
  yield takeLatest(CREATE_ESCALATION_POLICY, createPolicySaga);
  yield takeLatest(UPDATE_ESCALATION_POLICY, updatePolicySaga);
  yield takeLatest(DELETE_ESCALATION_POLICY, deletePolicySaga);
  yield takeLatest(TOGGLE_ESCALATION_POLICY, togglePolicySaga);
  yield takeLatest(FETCH_ESCALATION_EVENTS, fetchEventsSaga);
}
